import React from 'react';
import Timefilter from './Options/Timefilter';
import Datefilter from './Options/Datefilter';
import Batchfilter from './Options/Batchfilter';
import Boardfilter from './Options/Boardfilter';
import Branchfilter from './Options/Branchfilter';
import Standardfilter from './Options/Standardfilter';
import Subjectfilter from './Options/Subjectfilter';
import Levelfilter from './Options/Levelfilter';
import { useContext } from 'react';
import filterContext from '../context/filters/filterContext';
import '../styles/mainFilter.css';
import Schoolfilter from './Options/Schoolfilter';
import { ChcekBox, Checkbox } from 'antd';
import FilterContent from './filtercomponent';
function Mainfilter() {
	const {
		nameOfFilter,
		setnameOfFilter,
		handleFormSubmit,
		fetchConversationAcctoAllFilters,
		fetchAcctoTimeOnly,
		resetAllFilter,
		checked,
		selectedDate,
		batchfilter,
		standardfilter,
		boardsfilter,
		schoolFilter,
		subjectfilter,
		branchfilter,
		level,
		customFilterData,
	} = useContext(filterContext);

	var filterComponent;
	//  Referance
	//  Timefilter -> Time
	//  Datefilter -> Date
	if (nameOfFilter.name === 'Time') {
		filterComponent = <Timefilter />;
	} else if (nameOfFilter.name === 'Date') {
		filterComponent = <Datefilter />;
	} else {
		filterComponent = <FilterContent />;
		//  return(
		// 	<div>
		// 		<div>
		// 		{nameOfFilter.options.map((item, index) => (
		// 			<>
		// 				<div
		// 					className="filterStyle"
		// 					style={{ height: '60px', marginRight: '0px' }}
		// 					key={index}
		// 				>
		// 					<label htmlFor={`input-field${index + 1}`} className="labelStyle">
		// 						{item}
		// 					</label>
		// 					<Checkbox
		// 						id={`input-field${index + 1}`}
		// 						className="rounded-checkbox"
		// 						type="checkbox"
		// 						name={item}
		// 						checked={boardsfilter[`${item}`]}
		// 						// onChange={handleCheckboxChange}
		// 					/>
		// 				</div>
		// 				<hr />
		// 			</>
		// 		))}
		// 	</div>
		// 	</div>
		// )
	}
	// } else if (nameOfFilter === 'Batch') {
	// 	filterComponent = <Batchfilter />;
	// } else if (nameOfFilter === 'Standard') {
	// 	filterComponent = <Standardfilter />;
	// } else if (nameOfFilter === 'Board') {
	// 	filterComponent = <Boardfilter />;
	// } else if (nameOfFilter === 'Branch') {
	// 	filterComponent = <Branchfilter />;
	// } else if (nameOfFilter === 'Subject') {
	// 	filterComponent = <Subjectfilter />;
	// } else if (nameOfFilter === 'Level') {
	// 	filterComponent = <Levelfilter />;
	// } else if (nameOfFilter === 'School') {
	// 	filterComponent = <Schoolfilter />;
	// }

	return (
		<>
			<div className="mainFilter-container">
				{/* Left side of filters */}
				<div className="mainFilter-left">
					<div
						onClick={() => {
							setnameOfFilter({ name: 'Time' });
						}}
						className="filter-container"
					>
						<button className="filter-item">Time</button>
						{checked.timeOpt > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>1</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter({ name: 'Date' });
						}}
						className="filter-container"
					>
						<button className="filter-item">Date</button>
						{selectedDate != '' && (
							<p style={{ color: 'white', marginBottom: '0' }}>1</p>
						)}
					</div>

					{customFilterData.map(filter => (
						<div
							onClick={() => {
								setnameOfFilter(filter);
								const filterData = filter[filter.filterName];
								// console.log(Object.values(filter.filterName).filter(value => value).length)
							}}
							className="filter-container"
						>
							<button className="filter-item">{filter.filterName}</button>
							{Object.values(filter.filterName).filter(value => value).length > 0 && (
								<p style={{ color: 'white', marginBottom: '0' }}>
									{Object.values(filter.filterName).filter(value => value).length}
								</p>
							)}
						</div>
					))}
					{/* <div
						onClick={() => {
							setnameOfFilter('Batch');
							console.log(Object.values(batchfilter).filter(value => value).length)
						}}
						className="filter-container"
					>
						<button className="filter-item">Batch</button>
						{Object.values(batchfilter).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(batchfilter).filter(value => value).length}
							</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter('Standard');
						}}
						className="filter-container"
					>
						<button className="filter-item">Standard</button>
						{Object.values(standardfilter).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(standardfilter).filter(value => value).length}
							</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter('Board');
						}}
						className="filter-container"
					>
						<button className="filter-item">Board</button>
						{Object.values(boardsfilter).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(boardsfilter).filter(value => value).length}
							</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter('Branch');
						}}
						className="filter-container"
					>
						<button className="filter-item">Branch</button>
						{Object.values(branchfilter).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(branchfilter).filter(value => value).length}
							</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter('Subject');
						}}
						className="filter-container"
					>
						<button className="filter-item">Subject</button>
						{Object.values(subjectfilter).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(subjectfilter).filter(value => value).length}
							</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter('Level');
						}}
						className="filter-container"
					>
						<button className="filter-item">Level</button>
						{Object.values(level).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(level).filter(value => value).length}
							</p>
						)}
					</div>
					<div
						onClick={() => {
							setnameOfFilter('School');
						}}
						className="filter-container"
					>
						<button className="filter-item">School</button>
						{Object.values(schoolFilter).filter(value => value).length > 0 && (
							<p style={{ color: 'white', marginBottom: '0' }}>
								{Object.values(schoolFilter).filter(value => value).length}
							</p>
						)}
					</div> */}
					{/* <div className="blank-space">
						<button filter-item className="filter-item"></button>
					</div> */}
					<div style={{ padding: '10px' }} onClick={resetAllFilter}>
						<button className="btn btn-primary reset-button">Reset Filter</button>
					</div>
				</div>

				{/* Input fields of a particular filter */}
				{/* Right side of Filters */}
				<div
					className="mainFilter-right custom-scrollbar"
					style={{ maxHeight: '60vh' }}
				>
					<div>
						<form onSubmit={handleFormSubmit}>
							{filterComponent}
							<div
								style={{ display: 'flex', justifyContent: 'center', margin: 'auto' }}
							>
								<button className="btn btn-primary fixed-button" type="submit">
									Apply
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	);
}
export default Mainfilter;
